import { render, staticRenderFns } from "./InputTelephone.vue?vue&type=template&id=0980a9d2&"
import script from "./InputTelephone.vue?vue&type=script&lang=js&"
export * from "./InputTelephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports